<mat-card class="tabs-wrapper card-wrapper mat-card-layout">
    <div class="title">
        <span class="title-text">
            <prl-label value="label.modify.account.change.password"/>
        </span>
        <mx-info-tooltip [config]="resetPasswordConfig"></mx-info-tooltip>
    </div>

    <div class="content">
        <mx-object-form (customize)="onCustomize($event)">

        </mx-object-form>
    </div>
    <div class="actions">
        <mx-button [buttonModel]="submitButton"></mx-button>
    </div>
</mat-card>